import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from '../../Link/Link';
import { Props } from './interfaces';

const LinkMenu = ({ menu, className, children, onClickLink }: Props) => {
  let location = useLocation().pathname;

  const { link, text, subMenu, subComponent, intoLink, mark } = menu;

  const htmlText = (
    <p className={mark ? 'menu-top__link-with-mark' : ''} dangerouslySetInnerHTML={{ __html: text }}></p>
  );
  const htmlSubmenuText = (text: string) => (
    <p className="menu-top__item-submenu" dangerouslySetInnerHTML={{ __html: text }}></p>
  );

  const [styleSubComponent, setStyleSubComponent] = useState<any>({ opacity: '0', pointerEvents: 'none' });

  const onMenuClick = (link: string) => () => {
    if (onClickLink) {
      onClickLink();
    }
    if (window) {
      window.location.href = link;
    }
  }

  return (
    <div
      className={`menu-top__item-menu${link === location ? ' menu-top__item-menu_active' : ''}${
        className ? ` ${className}` : ''
      }`}
      onMouseLeave={() => setStyleSubComponent({ opacity: '0', pointerEvents: 'none' })}
      onMouseMove={(e) => {
        if ((e.target as HTMLElement).closest('.menu-top__item-menu')) {
          setStyleSubComponent({ opacity: '1', pointerEvents: 'all' });
          return;
        }
        setStyleSubComponent({ opacity: '0', pointerEvents: 'none' });
      }}
    >
      {link.length ? (
        intoLink ? (
          <a href={link} target="_blank" onClick={onClickLink ? onClickLink : () => {}}>
            {htmlText}
          </a>
        ) : (
          <Link to={link} onClick={onClickLink ? onClickLink : () => {}}>
            {htmlText}
          </Link>
        )
      ) : subMenu ? (
        <div className="menu-top__dropdown">{htmlText}</div>
      ) : (
        htmlText
      )}

      {subMenu ? (
        <div className="menu-top__submenu">
          {subMenu.map(({ text, link, intoLink }, idx) =>
            link.length ? (
              intoLink ? (
                <span key={idx} onClick={onMenuClick(link)}>
                  {htmlSubmenuText(text)}
                </span>
              ) : (
                <Link to={link} key={idx} onClick={onClickLink ? onClickLink : () => {}}>
                  {htmlSubmenuText(text)}
                </Link>
              )
            ) : (
              htmlSubmenuText(text)
            )
          )}
        </div>
      ) : null}

      {subComponent ? (
        <div className="menu-top__sub-component" style={styleSubComponent}>
          {subComponent({ onClickLink })}
        </div>
      ) : null}

      {children}
    </div>
  );
};

export default LinkMenu;
